import { compile } from '@casa/layout';

/**
 * A value through the tile's `transform` (legacy `ValueOptions.Transform`), which is also where a
 * unit is converted (`ftoc(value)`). No number (a bad expression, or one that gives no finite
 * number) shows as no data, as the legacy conversion that threw did.
 */
export function transformValue(value: number | null, transform: string | undefined) : number | null {
    if (value === null || transform === undefined) {
        return value;
    }

    try {
        const result = compile(transform).evaluate({ value });

        return typeof result === 'number' && Number.isFinite(result) ? result : null;
    } catch {
        return null;
    }
}
